<script>
export default {
    name: "ArrowDown"
}
</script>
<template>
    <svg role="img" aria-label="Arrow Down" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.28368 13.7863L6 14.5L6.71632 13.7895L11.2805 9.26218L12 8.54851L10.5642 7.12744L9.84786 7.83797L7.01426 10.6487L7.01426 1.50606L7.01426 0.5L4.98574 0.5L4.98574 1.50606L4.98574 10.6455L2.15214 7.83483L1.43582 7.12744L-3.51811e-07 8.54851L0.716322 9.25904L5.28051 13.7863L5.28368 13.7863Z" fill="white"/>
    </svg>
</template>
